/**
 * @description Can be swapped with the primary warning color.
 */

const orangeDark = {
  25: "#FFF9F5",
  50: "#FFF4ED",
  100: "#FFE6D5",
  200: "#FFD6AE",
  300: "#FF9C66",
  400: "#FF692E",
  500: "#FF4405",
  600: "#E62E05",
  700: "#BC1B06",
  800: "#97180C",
  900: "#771A0D",
  950: "#57130A",
};

export default orangeDark;
